<template>
  <div class="dialog-wrap">
    <el-dialog
      title="添加号码"
      :close-on-click-modal="false"
      :visible.sync="dialogVisible"
      @close="handleClose"
      width="784px"
    >
      <el-form
        class="form"
        :model="dataForm"
        :rules="rules"
        ref="formRules"
        label-width="0px"
      >
        <div class="tips">手动输入最多支持1000个号码</div>
        <el-form-item prop="phones">
          <el-input
            type="textarea"
            v-model="dataForm.phones"
            :rows="5"
          ></el-input>
        </el-form-item>
      </el-form>
      <div class="tips other">多个手机号请用逗号隔开。</div>
      <div
        slot="footer"
        class="dialog-footer"
      >
        <el-button @click="handleClose">取 消</el-button>
        <el-button
          type="primary"
          @click="handleSubmit('formRules')"
        >确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
  
  <script>


export default {
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    users: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      dialogVisible: this.visible,
      dataForm: {},
      rules: {
        phones: [{ required: true, message: "请添加号码", trigger: "blur" }],
      }
    }
  },
  watch: {
    visible(val) {
      this.dialogVisible = val
    },
    users(val) {
      this.$set(this.dataForm, 'phones', val.join(','))
    }
  },
  methods: {
    handleSubmit(rules) {
      this.$refs[rules].validate((valid) => {
        if (valid) {
          let arr = this.dataForm.phones.split(',')
          let ind = arr.findIndex((v, i) => { return !(/^[1][3,4,5,6,7,8,9][0-9]{9}$/.test(v)) })
          if (ind != -1) {
            this.$message.error(`请输入正确的手机号，错误位置：第${ind + 1}个`)
            return
          }
          this.$emit('submit', { data: arr })
          this.handleClose()
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    handleClose() {
      this.$emit('close')
    },
  }
}
  </script>
  
  <style lang="less" scoped>
.tips {
  font-size: 14px;
  font-weight: 400;
  color: #333333;
  line-height: 16px;
  margin-bottom: 18px;
}
.other {
  color: rgba(0, 0, 0, 0.4);
  margin-bottom: 0px;
  margin-top: 18px;
}
</style>
  